export default __webpack_public_path__ + "static/media/68t.d7cad113.jpg";